import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueLocalStorage from "vue-ls";

import Notifications from "vue-notification";
import helper from "./plugins/helper/index";
import "@/assets/styles/font.css";

import "@/assets/styles/notifications.scss";
import "@/assets/styles/dark.scss";
import "@mdi/font/scss/materialdesignicons.scss";
import "@/assets/styles/effects.css";
import "@/assets/styles/base.scss";
import "@/assets/styles/spinner.css";
import "bulma-tooltip/dist/css/bulma-tooltip.min.css";
import "bulma-calendar/dist/css/bulma-calendar.min.css";
import "@/assets/styles/notificationbar.css";
import "bulma-o-steps/bulma-steps.min.css"

import { init } from "@/utils/app";

Vue.use(VueLocalStorage);
Vue.use(Notifications);
Vue.use(helper);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    init();
  },
}).$mount("#app");
